import { render, staticRenderFns } from "./FaceApproveSearchHistoryPage.vue?vue&type=template&id=7fb951fd&scoped=true"
import script from "./FaceApproveSearchHistoryPage.vue?vue&type=script&lang=js"
export * from "./FaceApproveSearchHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./FaceApproveSearchHistoryPage.vue?vue&type=style&index=0&id=7fb951fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb951fd",
  null
  
)

export default component.exports